jQuery(document).ready(function ($) {

    $('.js-change-visitor input').on('change', change_visitor);
    $('.js-form-submit').on('click', submission);

    function change_visitor() {
        const $this = $(this),
            block = $(this).closest('.u-content-row'),
            offersField = block.find('input[name="offers"]').siblings(),
            visitorField = block.find('input[name="visitor"]');

        offersField.toggle();
        visitorField.val($this.val());
    }

    function submission() {
        const $this = $(this),
            form = $this.closest('form'),
            data = get_form_data(form);

        if (data) {
            $.ajaxWithRecaptcha({
                url: "/wp-json/form/submit",
                method: 'POST',
                data: data,
                beforeSend: function () {
                    $this.attr('disabled', true);
                    form.removeClass().addClass('flex-form processing').find('.is-error').removeClass('is-error');
                },
                success: function (response) {
                    $this.removeAttr('disabled');
                    form.removeClass('processing').addClass(response.status);

                    form.find('.js-message').html(response.message);

                    if (response.errors) {
                        $.each(response.errors, function () {
                            form.find('[name="' + this.name + '"]').closest('[class*="flex-form"]').addClass('is-error')
                        });
                    }
                }
            });
        }

        return false;
    }

    function get_form_data(form) {
        const $form = $(form);
        const nativeForm = $form.get(0);
        const formData = new FormData(nativeForm);

        const output = {};
        const entries = Array.from(formData.entries());

        const groupNames = new Set(
            entries
            .map(([key]) => key)
            .filter((key) => key.endsWith('[]'))
        );

        for (const groupName of groupNames) {
            const baseName = groupName.replace(/\[\]$/, '');
            const selected = formData.getAll(groupName);
            const values = {};

            for (const value of selected) {
                const dynamicInputName = `${baseName}_${value}`;
                const replacement = formData.get(dynamicInputName);

                if (replacement?.trim()) {
                    values[value] = replacement.trim();
                    formData.delete(dynamicInputName);
                } else {
                    values[value] = true;
                }
            }

            output[baseName] = values;
            formData.delete(groupName);
        }

        for (const [key, value] of formData.entries()) {
            output[key] = value;
        }

        return output;
    }

});